export const CHANGE_REQUEST_STATUS = {
  PENDING_APPROVED: "Pending Approval",
  DRAFT: "Draft",
  RETURNED: "Returned",
  APPROVED: "Approved",
  PUBLISHED: "Published",
  REJECTED: "Rejected",
  ACTIVE: "Active",
};
